const Xrp = () => (
    <svg
        width='116'
        height='116'
        viewBox='0 0 116 116'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='57.5503' cy='57.574' r='57.5' fill='#23292F' />
        <path
            d='M84.6821 27.674H95.1254L73.3952 49.1788C65.5288 56.9644 52.7772 56.9644 44.9108 49.1788L23.1834 27.674H33.6268L50.1339 44.0106C55.1143 48.942 63.1916 48.942 68.175 44.0106L84.6821 27.674ZM33.4939 87.474H23.0505L44.9136 65.8362C52.7801 58.0506 65.5317 58.0506 73.3981 65.8362L95.2612 87.474H84.8179L68.175 71.0044C63.1945 66.0731 55.1172 66.0731 50.1339 71.0044L33.4939 87.474Z'
            fill='white'
        />
    </svg>
);

export default Xrp;
